import { motion } from 'framer-motion';
import styled from 'styled-components';
import Theme from '@styles/Theme';
import { cardBorderImg } from '@styles/common/Card';
import { scrollbarHide, scrollbarStyle } from '@styles/variants/scrollbar';

export const ModalOverlay = styled(motion.div)`
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  position: fixed;
  backdrop-filter: blur(6px);
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: hidden;
  padding: 40px 0;
  z-index: 200;

  display: flex;
  justify-content: center;
  align-items: center;

  @media (max-width: 480px) {
    padding: env(safe-area-inset-top, 0px) 0 env(safe-area-inset-bottom, 0px);
  }
`;

export const ModalContent = styled(motion.div)`
  min-width: 550px;
  width: fit-content;
  max-width: 96%;
  height: auto;
  background: var(--backgroundColor);
  border-radius: var(--cardBorderRadius);
  box-shadow: ${Theme.shadow.modal};
  text-align: center;
  overflow: hidden;
  position: relative;

  ${cardBorderImg}

  @media (max-width: 768px) {
    max-width: 96%;
    max-height: 96vh;
    min-width: unset;
  }

  @media (max-width: 480px) {
    max-width: 100%;
    min-width: unset !important;
    width: 100%;
    max-height: 100%;
    border-radius: 0;
    height: 100%;
  }
`;

export const ModalHeader = styled.div<{
  mode?: 'dark';
}>`
  width: 100%;
  height: 60px;
  display: grid;
  grid-template-columns: auto 1fr auto;
  align-items: center;
  gap: 12px;
  color: var(--textColor);
  border-bottom: 1px solid var(--lineColor);
  z-index: 1;

  padding: 0 16px 0 8px;
  border-bottom: 1px solid var(--lineColor);
`;

export const ModalInner = styled(motion.div)<{
  maxHeight?: number;
  height?: number | string;
}>`
  overflow-y: auto;
  overflow-x: hidden;
  max-height: ${({ maxHeight }) => (maxHeight ? `${maxHeight}px` : '90vh')};
  height: ${({ height }) =>
    typeof height === 'number' ? `${height}px` : height || 'auto'};
  padding: 16px 24px 24px 24px;
  ${scrollbarStyle}

  @media (max-width: 480px) {
    padding: 16px;
    max-height: 100%;
  }
`;

export const InnerGrid = styled.div`
  display: flex;
  margin-bottom: 12px;
  gap: 24px;

  @media (max-width: 460px) {
    flex-direction: column;
  }
`;

export const FormGrid = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const ImgUploadGrid = styled.div<{
  height?: string;
}>`
  width: 100%;
  max-width: 300px;
  height: ${({ height }) => height || 'auto'};
  display: flex;
  flex-direction: column;
  gap: 12px;

  @media (max-width: 480px) {
    max-width: 100%;
    height: auto;
  }
`;

export const BtnWrap = styled.div`
  display: flex;
  gap: 4px;
  flex-wrap: wrap;
`;

export const ModalContentsGrid = styled.div`
  display: grid;
  grid-template-rows: 60px 1fr;

  max-height: 96%;
  width: 100%;
  position: relative;
  overflow: hidden;
  overflow-y: auto;
`;
